import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { TareaCasoService } from 'src/app/services/tareacaso.service';

@Component({
  selector: 'app-verificacion-candidato',
  templateUrl: './verificacion-candidato.component.html',
  styleUrls: ['./verificacion-candidato.component.scss'],
})
export class VerificacionCandidatoComponent implements OnInit {
  form: FormGroup;
  caso;
  idCaso;
  @Input() data: { task: any };

  constructor(
    private fb: FormBuilder,
    public _caso: CasoTareaService,
    public _snackbar: MatSnackBar,
    public _tareacaso: TareaCasoService
  ) {}

  ngOnInit(): void {
    this._caso.getById(this.data.task.idCaso).subscribe((response) => {
      this.caso = response;
    });
    const { task } = this.data;
    const values = task.data ? task.data : null;

    this.form = this.fb.group({
      tiene_cuenta: [
        values ? values.tiene_cuenta : false,
        [Validators.required],
      ],
      validos: [values ? values.validos : '', [Validators.required]],
      localidad: [values ? values.localidad : false, [Validators.required]],
      validas_referencias: [
        values ? values.validas_referencias : '',
        [Validators.required],
      ],
      laboro: [values ? values.laboro : false, [Validators.required]],
      soporte: [values ? values.soporte : '', [Validators.required]],
      figura: [values ? values.figura : false, [Validators.required]],
      antecedentes: [values ? values.antecedentes : '', [Validators.required]],
      elegible: [values ? values.elegible : '', [Validators.required]],
      observaciones: [
        values ? values.observaciones : '',
        [Validators.required],
      ],
    });
  }
}
